import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainSection } from './components/PainSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { PricingSection } from './components/PricingSection';
import { ComparisonTable } from './components/ComparisonTable';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostTable } from './components/CostTable';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { TopAnnouncementBar } from './components/TopAnnouncementBar';
import { TrustMarquee } from './components/TrustMarquee';
import { MoreTestimonials } from './components/MoreTestimonials';
import { BackgroundFX } from './components/BackgroundFX';
import { LiveActivityTicker } from './components/LiveActivityTicker';
import { MetricsStrip } from './components/MetricsStrip';
import { TerminalDivider } from './components/TerminalDivider';
export function App() {
  return <div className="min-h-screen bg-graphite text-white font-body selection:bg-electric selection:text-graphite relative" data-id="element-0">
      <BackgroundFX data-id="element-1" />

      <div className="relative z-10 flex flex-col min-h-screen" data-id="element-2">
        <MetaPixel data-id="element-3" />
        <TopAnnouncementBar data-id="element-4" />
        <TrustMarquee data-id="element-5" />
        <LiveActivityTicker data-id="element-6" />
        <Hero data-id="element-7" />
        <PainSection data-id="element-8" />
        <Testimonials data-id="element-9" />
        <MetricsStrip data-id="element-10" />
        <TerminalDivider command="npm install sistema-freelancer" data-id="element-11" />
        <TomosSection data-id="element-12" />
        <BonosSection data-id="element-13" />
        <TerminalDivider command="unlock bonos --all --free" data-id="element-14" />
        <PricingSection data-id="element-15" />
        <ComparisonTable data-id="element-16" />
        <TerminalDivider command="scale to USD 1.000/mes" data-id="element-17" />
        <MoreTestimonials data-id="element-18" />
        <GuaranteeSection data-id="element-19" />
        <FAQSection data-id="element-20" />
        <CostTable data-id="element-21" />
        <FinalCTA data-id="element-22" />
        <Footer data-id="element-23" />
      </div>
    </div>;
}